<template>
    <modal @close="$emit('close')" :autoshow="true" ref="modal" :is-closeable="isCloseable">
        <template v-slot:title>Edit Social Security Number</template>

        <template v-slot:subheading>
            <div class="p-1 unpad-x bg-150 rounded">
                <div><span class="text-muted">Employee:</span> {{ employee.full_name }}</div>
                <div><span class="text-muted">Company:</span> {{ employee.company.name }}</div>
            </div>
        </template>

        <slot>
            <div>
                <div v-if="!confirmedSensitiveInfo">
                    <p>You are about to view sensitive employee information.</p>
                    <p>
                        <strong>If you proceed, your attempt to view this information will be logged and a notification sent to the appropriate company leadership.</strong>
                    </p>
                </div>
                <form v-if="confirmedSensitiveInfo">
                    <form-errors :errors="formErrors"/>

                    <div class="form-row">
                        <div class="col-10">
                            <form-input label="Social Security Number" v-model="formData.ssn" :errors="errors.ssn" type="ssn" />
                        </div>
                    </div>
                </form>
            </div>
        </slot>

        <template v-slot:footer>
            <div class="form-row">
                <div class="col">
                    <button type="button" class="btn btn-block btn-outline-primary" @click.prevent="close()">Cancel</button>
                </div>
                <div class="col">
                    <button v-if="!confirmedSensitiveInfo" type="button" class="btn btn-block btn-primary" @click.prevent="getSSN">Continue</button>
                    <button v-else type="submit" class="btn btn-block btn-primary" @click.prevent="onSubmit">Save</button>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import ModalMixin from '@/mixins/ModalMixin'
import FormMixin from '@/mixins/Form'

export default {
    mixins: [ModalMixin, FormMixin],
    components: {},
    props: ['client', 'employee', ],
    data() {
        return {
            confirmedSensitiveInfo: false,
            formData: this.makeFormData(),
        }
    },
    methods: {
        makeFormData() {
            return {
                ssn: '',
            }
        },
        getFormData() {
            return this.formData
        },
        getSSN() {
            this.$api.get(`/clients/${this.client.id}/employees/${this.employee.id}/ssn`).then(resp => {
                this.formData.ssn = resp
                this.confirmedSensitiveInfo = true
            }).catch(errors => {
                this.$bus.showError(errors.__all__)
            })
        },
        onSubmit() {
            this.errors = {}
            this.formErrors = []
            this.$api.patch(`/clients/${this.client.id}/employees/${this.employee.id}/ssn`, this.getFormData()).then(resp => {
                this.$emit('updated')
                this.close()
            }).catch(errors => {
                this.errors = errors
                this.formErrors = errors.__all__
            })
        },
    }
}
</script>
